import isNil from 'lodash-es/isNil'
import { BooleanParam, StringParam, useQueryParam, useQueryParams } from 'use-query-params'

import { useQueryPage } from '@fourthwall/utils'

type FilterParams = {
  type?: string
  tier?: string
  billingCycle?: string
  state?: string
  giftedByOthers?: boolean
}

export const useFilterMembers = () => {
  const { setPage } = useQueryPage()
  const [queryParams, setQueryParams] = useQueryParams({
    type: StringParam,
    tier: StringParam,
    billingCycle: StringParam,
    state: StringParam,
    giftedByOthers: BooleanParam,
  })
  const [searchQueryParam, setSearchQueryParam] = useQueryParam('searchQuery', StringParam)

  const resetFiltersParams = () => {
    setPage(undefined)
    setQueryParams({
      type: undefined,
      tier: undefined,
      billingCycle: undefined,
      state: undefined,
      giftedByOthers: undefined,
    })
  }

  const setFiltersParams = (params: FilterParams) => {
    setPage(undefined)
    setQueryParams(params)
  }

  const hasFilterParams =
    Object.values(queryParams).some((param) => !isNil(param)) || !!searchQueryParam

  return {
    filtersParams: queryParams,
    setFiltersParams,
    searchQueryParam,
    setSearchQueryParam,
    resetFiltersParams,
    hasFilterParams,
  }
}
